var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabi"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"content mt-1"},[_vm._t("default")],2),_c('BottomNav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }